/**
 * CSS px a press may travel and still be a click. Past it the gesture is a
 * drag, so a tremor cannot locate a voxel on another ray.
 */
export const CLICK_SLOP_PX = 4;

/** Whether straight-line travel from `start` to `end` is within the slop. */
export function isWithinClickSlop(
    start: readonly [number, number],
    end: readonly [number, number]
): boolean {
    return Math.hypot(end[0] - start[0], end[1] - start[1]) <= CLICK_SLOP_PX;
}
